<template>
	<v-row justify="center">
		<v-dialog v-model="$store.state.ui.tokenRefreshDialog" persistent max-width="450">
			<v-card class="pa-4">
				<v-card-title class="pb-0">
					Actualización de autenticación
				</v-card-title>
				<v-card-text class="pb-0">
					<v-form
						ref="form"
						v-model="ui.valid"
						lazy-validation
						@submit.prevent="login()"
					>
						<v-row>
							<v-col cols="12">
								La autenticación para este sitio ha caducado. Es necesario autenticar nuevamente para poder continuar.
							</v-col>
							<v-col cols="12" class="mt-0 pb-0">
								<v-text-field
									dense
									outlined
									clearable
									type="email"
									autocomplete="off"
									:rules="[v.required]"
									@keydown.enter="login()"
									label="Correo electrónico"
									v-model="layout.credentials.email"
								></v-text-field>
							</v-col>							
							<v-col cols="12" class="mt-0 pb-0 pt-0">
								<v-text-field
									dense
									outlined
									clearable
									autocomplete="off"
									label="Contraseña"
									:rules="[v.required]"
									@keydown.enter="login()"
									v-model="layout.credentials.password"
									:type="ui.show_password ? 'text' : 'password'"
									:append-icon="ui.show_password ? 'mdi-eye' : 'mdi-eye-off'"
									@click:append="ui.show_password = !ui.show_password"
								></v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<!-- <v-btn color="primary" text @click="ui.dialog = false"> -->
						<!-- cancelar -->
					<!-- </v-btn> -->
					<v-btn
						color="primary"
						@click="login()"
						:disabled="!ui.valid"
						:loading="ui.storing"
					>
						Enviar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { EventBus } from "@/main";
import axios from "axios";
import Validations from "@/../../GeneralComponents/Validations";

export default {
	name: "RefreshAuth",

	data() {
		return {
			v: Validations,
			session: {},
			layout: {
				typeAuth: "user/password",
				credentials: {
					email: null,
					password: null,
				},
			},
			ui: {
				dialog: false,
				
				storing: false,

				show_password: false,

			},
		};
	},

	created() {
		EventBus.$on("TokenRefresh", () => {
			this.ui.dialog = true;
		});
	},

	methods: {
		async login() {
			if (this.$refs.form.validate()) {
				try {
					this.ui.storing = true;

					let response = await axios.post(
						`${process.env.VUE_APP_API_SERVER}/auth/login`,
						this.layout
					);

					localStorage.setItem("session", JSON.stringify(response.data.data));

					this.$store.dispatch("startApp");

					this.$store.dispatch("setTokenRefreshDialog", false);
				} catch (error) {
					EventBus.$emit("Error", { error: error, errorsShow: true });
				}

				this.ui.storing = false;
			}
		},
	},
};
</script>

<style lang="css" scoped></style>
